import React from 'react';

import './page.css';

//
import MainTitle from '../../components/page/main-title/MainTitle';
import STRINGS from './../../data/language/language';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';
import EmptyList from '../../components/emptyList/EmptyList';
import LoadingPage from '../../components/loading/LoadingPage';
import { Closest } from '../../utils/htmlnodes/Selectors';
import TextInput from '../../components/form/TextInput';
import ButtonAdd from '../../components/form/ButtonAdd';
import ItemSimplesListagem from '../../components/listagem/ItemSimplesListagem';
import Button from '../../components/buttons/Button';
import Container from '../../components/container/Container';
import Modal from '../../components/modal/Modal';
import Paginacao from '../../components/paginacao/Paginacao';
import Page from './Page';
import {FormDataToJson} from '../../utils/json/Json';
// import route Components here
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  Redirect
} from 'react-router-dom';

const URL_REMOVE_ITEM = WS.clientes.remove;
const URL_LISTA = WS.clientes.lista;
const URL_DETALHE_ITEM = WS.clientes.detalhe;

class Clientes extends React.Component{
  constructor (props){
    super(props);
    this.state = {
      strings:STRINGS[window.LANGUAGE],
      lista: [],
      isLoading: true,
      searchStatus: false
    }

    this.handleClick = this.handleClick.bind(this);
    this.btEditClick = this.btEditClick.bind(this);
    this.remove = this.remove.bind(this);
    this.onRemoveItem = this.onRemoveItem.bind(this);
    this.searchClientes = this.searchClientes.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.searchClienteHandler = this.searchClienteHandler.bind(this);
    this.pageHandler = this.pageHandler.bind(this);
  }

  componentDidMount() {
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);

    const {atencao} = this.state.strings;
    let _self = this;

    Requisitions({
      url:URL_LISTA,
      data:{},
      sucess:function(data){
        var msg;

        if(data.status){
          _self.setState({
            lista: data.items,
            page: data.page
          });
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }

  componentWillUnmount() {

  }

  searchClienteHandler(e){
    e.preventDefault();

    const formData = new FormData(e.target);
    var object = FormDataToJson(formData);

    const {atencao} = this.state.strings;
    let _self = this;

    e.target.reset();

    Requisitions({
      url:URL_LISTA,
      data:object,
      sucess:function(data){
        var msg;

        if(data.status){
          _self.setState({
            lista: data.items,
            page: data.page
          });
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }

  pageHandler(val){

    const {atencao} = this.state.strings;
    let _self = this;
    Requisitions({
      url:URL_LISTA,
      data:{ page: val},
      sucess:function(data){
        var msg;

        if(data.status){
          _self.setState({
            lista: data.items,
            page: data.page
          });
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }

  searchClientes(e) {
    e.preventDefault();
    this.setState({
      searchStatus: !this.state.searchStatus
    });
  }

  onRemoveItem (e,data){
    Dialog.destroy();
    const {
      msgRemover,
      atencao,
      fechar,
      remover,
      itemRemovidoSucesso,
      impossivelRemoverItem,
      erroRemover
    } = this.state.strings;
    //----------------
    const id = data.id;
    const item = Closest(e,'.item-listagem');

    Requisitions({
      url:URL_REMOVE_ITEM,
      data:{ id: id },
      sucess:function(data){
        var msg;
        if(data.status){
          msg = {
            title: atencao,
            text: itemRemovidoSucesso
          };

          //remove o item
          item.remove();
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
        }
        Dialog.create(msg);
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroRemover
        });
      }
    });
    //----------------
  }

  handleInputChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  remove (element) {
    const button = element.currentTarget;
    const {msgRemover,atencao,fechar,remover} = this.state.strings;
    const _self = this;
    const item = Closest(button,'.item-listagem');
    const id = item.getAttribute('data-id');

    this.checkId(id);

    Dialog.create({
      type: Dialog.CONFIRM,
      title: atencao,
      text: msgRemover,
      txtCancel: fechar,
      txtOk: remover,
      onSubmit: (el) => {
        _self.onRemoveItem(button,{id:id});
        el.preventDefault();
      }
    });
    element.preventDefault();
  }

  checkId (id){
    const {atencao,impossivelRemoverItem} = this.state.strings;
    if(!id){
      Dialog.create({
        title: atencao,
        text: impossivelRemoverItem
      });
      return false;
    }
  }

  btEditClick (e){
    const item = Closest(e.currentTarget,'.item-listagem');
    const id = item.getAttribute('data-id');
    const {atencao,erroDetalhe} = this.state.strings;
    this.checkId(id);

    const history = this.props.history;

    Requisitions({
      url:URL_DETALHE_ITEM,
      data:{ id: id },
      sucess:function(data){
        var msg;

        if(data.status){
          var modal = new Modal();
          modal.open({page:<Page modal={modal} detalhe={data.item} history={history} />});
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroDetalhe
        });
      }
    });

    //ao clicar no botão ao apertar enter o handleclick era chamado, o blur previne que ele seja chamado sempre
    document.activeElement.blur();

    e.preventDefault();
  }

  handleClick(e) {
    var modal = new Modal();
    modal.open({page:<Page modal={modal} history={this.props.history}  />});

    //ao clicar no botão ao apertar enter o handleclick era chamado, o blur previne que ele seja chamado sempre
    document.activeElement.blur();

    e.preventDefault();
  }

  render (){
    let lista = this.state.lista.map((value, i) =>
        <ItemSimplesListagem id={value.id} value={value.nome} key={i} btEditClick={this.btEditClick}  hideBtRemove></ItemSimplesListagem>
      );

    if(lista.length<=0){
      lista = <EmptyList />
    }

    const { titleExercicios } = this.state.strings;

    let wrapper = this.state.isLoading ? <LoadingPage /> : lista;
    const strings = this.state.strings;
    const searchStatus = this.state.searchStatus ? 'ativo' : '';

    return (
      <Container>
        <MainTitle
          title="Clientes"
          onSearch={this.searchClientes}
        />
      <div className={`${searchStatus} form-search`}>
          <form onSubmit={this.searchClienteHandler}>
            <div className='pure-u-6-24'>
              <TextInput
                onChange={this.handleInputChange}
                name="nome"
                title={strings.txtNome}
                placeholder={strings.digiteAqui}>
              </TextInput>
            </div>
            <div className='pure-u-6-24'>
              <TextInput
                onChange={this.handleInputChange}
                name="email"
                title={strings.txtEmailCadastro}
                placeholder={strings.digiteAqui}>
              </TextInput>
            </div>
            <div className='pure-u-6-24'>
              <TextInput
                onChange={this.handleInputChange}
                name="cpf_cnpj"
                title={strings.txtCpf}
                placeholder={strings.digiteAqui}>
              </TextInput>
            </div>
            <br />
            <div className="separador"></div>
            <br />
            <div className="box-right-button"><Button type="submit" text={strings.buscar} classes="bt-save bt-blue" /></div>
          </form>
        </div>
          <div className="listagem">
            {wrapper}
          </div>
          <Paginacao data={this.state.page} pageHandler={this.pageHandler} />
      </Container>
    );
  }
}

export default Clientes;



// WEBPACK FOOTER //
// ./src/classes/clientes/Clientes.js